const t = {
  button: "adyen-pe-grant-action__button"
};
export {
  t as GRANT_ACTION_CLASS_NAMES
};
